const dispatch = require("~/store.js").dispatch;
const server = require("~/server.js");
const navigator = require("~/navigator.js");
const config = require("~/config.js");

const Section = require("~/types/Section.js");
const QuestionValidationStatus = require("~/types/QuestionValidationStatus.js");

const events = require("./sectionEvents.js");

function asQuestionUpdate(question) {
    const answers = question.AnswerSelections
        .map(a => a.SelectionText);
    const update = {
        GUID: question.GUID,
        Answers: answers,
        Comment: question.AdditionalComment,
        Task: question.Task,
        Question: question.DisplayHTML
    };

    return update;
}

function save(pageIDPath, sectionID, answers, continueToSectionID, runAfterward) {
    const pageID = pageIDPath[pageIDPath.length - 1];

    const sectionLocationSeg = pageIDPath.concat(sectionID).join("/");

    const path = `audit/${sectionLocationSeg}/answers`;
    
    dispatch((thunkDispatch) => {
        const saving = events.Saving.New(pageID, sectionID);

        thunkDispatch(saving);

        let tries = 0;

        const updater = () => {
            server.Put(path, answers)
                .then(() => {
                    const saved = events.Saved.New(pageID, sectionID);

                    thunkDispatch(saved);
                    
                    if (continueToSectionID) {
                        navigator.InCurrentPage.GoToSection(continueToSectionID);
                    }
                    else if (runAfterward) runAfterward();
                })
                .catch((ex) => {
                    if (tries < config.ServerRequestRetries && ex.response.status >= 500) {
                        tries++;

                        setTimeout(updater, config.ServerRequestDelayMS);
                    }
                    else {
                        const errored = events.SaveErrored.New(pageID, sectionID, ex);

                        thunkDispatch(errored);
                    }
                });
        };

        updater();
    });
}

const sectionDispatchers = {
    Save(pageIDPath, currentSection, runAfterward) {
        const answers = currentSection.Questions.map(asQuestionUpdate);
        if (answers.length > 0 && answers[0].Question.includes('If not, the remaining questions in this section will be skipped') && (answers[0].Answers.includes('No') || answers[0].Answers.includes('N/A'))) {
            for (let i = 1; i < answers.length; i++) {
                let answer = ["N/A"];
                answers[i].Answers = answer;
            }
        }

        save(pageIDPath, currentSection.GUID, answers, null, runAfterward);
    },
    LeaveSection(pageIDPath, currentSection, questionSnapshot, nextSectionID) {
        const validatedSection =
            QuestionValidationStatus.SectionWithValidation(currentSection);

        let anyInvalid = validatedSection.Questions.some(q => !q.ValidationStatus.IsValid);
        const answers = currentSection.Questions.map(asQuestionUpdate);
        if (answers.length > 0 && answers[0].Question.includes('If not, the remaining questions in this section will be skipped') && (answers[0].Answers.includes('No') || answers[0].Answers.includes('N/A'))) {
            anyInvalid = false;
        }
                
        const hasChanges = Section.QuestionsDiffer(
            currentSection,
            questionSnapshot);
        
        if (!anyInvalid && !hasChanges) {
            navigator.InCurrentPage.GoToSection(nextSectionID);

            return;
        }

        if (anyInvalid) {
            const pageID = pageIDPath[pageIDPath.length - 1];

            const invalidEvent = events.UpdateQuestions.New(pageID, validatedSection);

            dispatch(invalidEvent);

            if(!confirm("One or more questions still need valid answers.\r\n"
                + "Are you sure you want to leave this section?")) {
                return;
            }
        }

        save(pageIDPath, currentSection.GUID, answers, nextSectionID);
    },
    ClearError(pageID, sectionID) {
        const clear = events.ClearErrors.New(pageID, sectionID);

        dispatch(clear);
    }
};

module.exports = sectionDispatchers;


// WEBPACK FOOTER //
// ./src/events/section/sectionDispatchers.js